import React, { useState } from "react";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./DiasDisponibles.css";
import CheckBoxGroup from "../../Genericos/CheckBoxGroup/CheckBoxGroup";
import {
  diasDisponiblesArray,
  horarioDisponibleArray,
} from "./ArrayDisponibilidad";

const DiasDisponibles = ({ titulo, dissmiss, onHandleDiasDisponibles }) => {
  const [arrxDias, setArrxDias] = useState(diasDisponiblesArray);
  const [arrxHorarios, setArrxHorarios] = useState(horarioDisponibleArray);

  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  const handleChangeRango = (e) => {
    setArrxHorarios(() => {
      return e;
    });
  };

  const handleChangeDia = (e) => {
    setArrxDias(() => {
      return e;
    });
  };

  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);
  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-diasDisponibles-container">
        <p className="ptur-diasDisponibles-txt">
          Indique disponibilidad de días y horas para la toma de turno
        </p>
        <div className="ptur-diasDisponibles-filtrosBox">
          <div className={`ptur-diasDisponibles-checkboxes`}>
            <span className="ptur-diasDisponibles-checkTitle rb16mh">
              Días disponibles
            </span>
            <CheckBoxGroup data={arrxDias} onChange={handleChangeDia} />
          </div>
          <div className={`ptur-diasDisponibles-checkboxes`}>
            <span className="ptur-diasDisponibles-checkTitle rb16mh">
              Rangos horarios
            </span>
            <CheckBoxGroup data={arrxHorarios} onChange={handleChangeRango} />
          </div>
        </div>
        <div className="ptur-diasDisponibles-btn-box">
          <button
            className="ptur-diasDisponibles-btnVolver c-latex30 rb16m"
            onClick={dissmiss}
          >
            Volver
          </button>
          <button
            className="ptur-diasDisponibles-btnBuscar c-white rb16m"
            onClick={() => onHandleDiasDisponibles(arrxDias, arrxHorarios)}
          >
            Siguiente
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiasDisponibles;
